import React from "react";

import Container from "@mui/material/Container";

const Unauthorized = () => {
  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "85vh" }}
    >
      <div class="d-flex flex-column align-items-center justify-content-center text-center p-5">
        <svg
          class="text-primary"
          width="100"
          height="100"
          fill="currentColor"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#828282"
            d="M16-0.034C7.159-0.034-0.035,7.158-0.035,16S7.159,32.034,16,32.034S32.035,24.842,32.035,16
    S24.841-0.034,16-0.034z M16,30.966C7.748,30.966,1.035,24.252,1.035,16S7.748,1.034,16,1.034S30.965,7.748,30.965,16
    S24.252,30.966,16,30.966z"
          />
          <path
            fill="#828282"
            d="M16.163,19.823c-2.789,0-5.477,1.179-7.374,3.235c-0.2,0.217-0.187,0.555,0.031,0.755
    c0.216,0.2,0.554,0.188,0.755-0.03c1.695-1.838,4.096-2.892,6.587-2.892c2.529,0,4.956,1.081,6.656,2.967
    c0.105,0.116,0.251,0.176,0.397,0.176c0.128,0,0.256-0.045,0.358-0.138c0.219-0.197,0.237-0.535,0.039-0.755
    C21.709,21.032,18.994,19.823,16.163,19.823z"
          />
          <path
            fill="#828282"
            d="M10.5,16.5c1.103,0,2-0.897,2-2s-0.897-2-2-2s-2,0.897-2,2S9.397,16.5,10.5,16.5z M10.5,13.5
    c0.551,0,1,0.448,1,1s-0.449,1-1,1s-1-0.448-1-1S9.949,13.5,10.5,13.5z"
          />
          <path
            fill="#828282"
            d="M21.5,16.5c1.103,0,2-0.897,2-2s-0.897-2-2-2s-2,0.897-2,2S20.397,16.5,21.5,16.5z M21.5,13.5
    c0.551,0,1,0.448,1,1s-0.449,1-1,1s-1-0.448-1-1S20.949,13.5,21.5,13.5z"
          />
        </svg>
        <h1 class="TitulosProgramas fw-bold mt-4">¡Lo sentimos!</h1>
        <p class="text-muted fs-4">No cuentas con los permisos suficientes</p>
        <p class="text-muted fs-4">Favor de contactar al administrador</p>
      </div>
    </Container>
  );
};

export default Unauthorized;
